/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import { useSelector } from 'react-redux';
import ComponentExpenseCustomer from './ComponentExpenseCustomer';
import ComponentExpenseMainTable from './ComponentExpenseMainTable';
import { ExpenseReports } from '../../types';
import ComponentExpenseAnalystTable from './ComponentExpenseAnalystTable';
import { RootState } from '../../../../redux/rootState';
import ComponentTotalExpenseTable from './ComponentTotalExpenseTable';
// import { CombineReportEnum, PDFReportEnum, ReportPart1 } from '../../helper';

function ExpenseReport() {
  const { reportPdfResponse4 } = useSelector((state: RootState) => state.reportPdfSliceReducer);

  return (
    <>
      {/* {reportPdfResponse4.Expense_Report?.map((item: ExpenseReports, index: number) => (
        <>
          {index > 0 && <div className="page-break" />}
          <div className="ExpenseReportPDFDiv">
            <div className="topHeader">
              <div>
                {`${ReportPart1(tableContent, CombineReportEnum.COMBINE_EXPENSE_REPORT, PDFReportEnum.PDF_EXPENSE_REPORT, 'Expense Report')} - Page - ${index + 1}`}
              </div>
              <div />
            </div>
            <ComponentExpenseCustomer customerData={item.Customerdata} />
            <ComponentExpenseMainTable mainTableData={item} />
            <ComponentExpenseAnalystTable expenseAnalystTable={item} />
          </div>
        </>
      ))} */}

      {reportPdfResponse4.Expense_Report?.map((item: ExpenseReports, index: number) => (
        <>
          {/* Only render if ExpenseReports is not empty */}
          {item.ExpenseReports.length > 0 && (
          <>
            {index > 0 && (reportPdfResponse4.Expense_Report?.[index - 1]?.ExpenseReports?.length > 0) && <div className="page-break" />}
            <div className="ExpenseReportPDFDiv">
              {/* <div className="topHeader">
                <div>
                  {`${ReportPart1(
                    tableContent,
                    CombineReportEnum.COMBINE_EXPENSE_REPORT,
                    PDFReportEnum.PDF_EXPENSE_REPORT,
                    'Expense Report',
                  )} - Page - ${index + 1}`}
                </div>
                <div />
              </div> */}
              <div className="pageHeader">
                <div className="underlineHeadingText textCenter pb10">{`Expense Report ${index === 0 && reportPdfResponse4.Expense_Report?.length > 1 ? '(A - ' : (index === 1 ? '(B - ' : (index === 2 ? '(C - ' : '('))}${item?.JobOrder})`}</div>
              </div>
              <ComponentExpenseCustomer customerData={item.Customerdata} />
              <ComponentExpenseMainTable mainTableData={item} />
              <ComponentExpenseAnalystTable expenseAnalystTable={item} />
              {reportPdfResponse4?.Expense_Report?.length > 1 && index === reportPdfResponse4.Expense_Report.length - 1 && <ComponentTotalExpenseTable />}
            </div>
          </>
          )}
        </>
      ))}

    </>
  );
}

export default ExpenseReport;
